import dayjs from 'dayjs'
import { BRAND_FILTER_TYPE, IBrandSummaryState } from './brand.types'

export const BrandSummaryState: IBrandSummaryState = {
  loaders: {
    outerGroupSummary: false,
    innerSummaryItems: false,
    fetchingProductMapping: false,
    uploadingProductMapping: false
  },
  activeFilter: {
    startTime: dayjs('04/01/2024').startOf('day').unix(),
    endTime: dayjs('04/01/2024').endOf('day').unix(),
    filterType: BRAND_FILTER_TYPE.CUSTOM
  },
  brandSaleSummary: null,
  brandOverallSaleSummary: null,
  brandReportItems: null,
  filterDrawerType: '',
  dataList: [],
  filteredData: {
    distributorNameFilter: [],
    productCodeFilter: [],
    productDescriptionFilter: [],
    regionFilter: [],
    branchFilter: []
  },
  downloadFilteredView: false,
  brandProductMapping: [],
  allProductCode: new Set<string>(),
  allProductName: new Set<string>(),
  productCodeToProductIdMapper: new Map(),
  productNameToProductIdMapper: new Map(),

  page: 1,
  pageSize: 10,
  totalCount: Infinity
}
